import { useState, useEffect, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import styles from "./promotionBonusPop.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { checkPromotionBonus } from "../../../lib/store/actions";
import loader from "../../../assets/images/loading.gif";
import promotionImg from "../../../assets/images/promotionPop.png";
import { showToast } from "../../../helper/common";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../hooks/useLanguage";

const PromotionBonusPop = ({
  showPromotionBonus,
  setShowPromotionBonus,
  onFinish,
}) => {
  // const { t } = useTranslation();
  const t = useLanguage();

  const dispatch = useDispatch();
  const { promotionBonusLoading } = useSelector(({ Auth }) => Auth);
  const [inputValue, setInputValue] = useState("");
  const modalRef = useRef(null);
  const inputRef = useRef(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);

  useEffect(() => {
    // Detect iOS
    setIsIOS(
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
  }, []);

  const handledHide = () => {
    setShowPromotionBonus(!showPromotionBonus);
    setInputValue("");
  };

  const handleFocus = () => {
    setIsInputFocused(true);
  };

  const handleBlur = () => {
    setIsInputFocused(false);
  };

  useEffect(() => {
    if (showPromotionBonus && inputRef.current && !isIOS) {
      inputRef.current.focus({ preventScroll: true });
    }
  }, [showPromotionBonus, isIOS]);

  const handleFirstTouch = (e) => {
    if (isIOS && inputRef.current) {
      e.preventDefault();

      // Create and focus a temporary invisible input
      const tempInput = document.createElement("input");
      tempInput.style.position = "absolute";
      tempInput.style.opacity = "0";
      tempInput.readOnly = true;
      document.body.appendChild(tempInput);
      tempInput.focus();

      setTimeout(() => {
        inputRef.current.focus({ preventScroll: true });
        document.body.removeChild(tempInput);
        setIsInputFocused(true);
      }, 100);
    }
  };
  useEffect(() => {
    const input = inputRef.current;
    if (isIOS && input) {
      input.addEventListener("touchstart", handleFirstTouch, { once: true });
    }
    return () => {
      if (input) {
        input.removeEventListener("touchstart", handleFirstTouch);
      }
    };
  }, [isIOS]);

  const handlePopUp = () => {
    // if (!inputValue || inputValue.trim() === "") {
    //   showToast("Please enter a code", 'error', { autoClose: 3000 });
    //   return;
    // }
    if (inputRef.current) {
      inputRef.current.blur();
    }
    const audio = new Audio("https://sound.bitanicagames.com/claim.mp3");

    dispatch(
      checkPromotionBonus({
        data: { promocode: inputValue },
        callBack: (err, res) => {
          if (err) {
            return;
          }
          if (res && res.status === "success") {
            audio.play().catch((error) => {
              console.error("Error playing audio:", error);
            });
            onFinish(res?.data);
          } else {
            showToast(res?.message, "error", {
              autoClose: 3000,
            });
            handledHide();
            setInputValue("");
          }
        },
      })
    );
  };

  const handleCodeChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      inputRef.current?.blur();
    }
  };

  return (
    <Modal
      ref={modalRef}
      show={showPromotionBonus}
      onHide={handledHide}
      scrollable={true}
      backdrop="static"
      keyboard={false}
      centered
      className={`${styles.promotionPop} bottomPop`}
    >
      <div className="modalWrpper">
        <Modal.Body>
          <Button
            onClick={handledHide}
            variant="transparent"
            className="border-0 p-0 position-absolute"
            style={{ top: 5, right: 5 }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="15"
              viewBox="0 0 26 26"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.0024 26.0048C20.1834 26.0048 26.0048 20.1834 26.0048 13.0024C26.0048 5.82137 20.1834 0 13.0024 0C5.82137 0 0 5.82137 0 13.0024C0 20.1834 5.82137 26.0048 13.0024 26.0048ZM13.0062 14.1485L18.1747 19.3251L19.3205 18.1711L14.152 13.0026L19.3205 7.83412L18.1747 6.68827L13.0062 11.8568L7.83767 6.68015L6.6837 7.83412L11.8603 13.0026L6.6837 18.1711L7.83767 19.3251L13.0062 14.1485Z"
                fill="#506380"
              />
            </svg>
          </Button>
          <div className="mx-auto" style={{ maxWidth: 300 }}>
            <div className="top text-center pt-4">
              <img src={promotionImg} alt="" className="img-fluid w-100" />
            </div>

            <div className="text-center">
              <div className="py-2">
                <h4 className="m-0 text-white fw-bold">
                  {t("promotionBonus_pop.to_claim")}{" "}
                  <span className="" style={{ color: "#2421f6" }}>
                    {t("promotionBonus_pop.prize")}
                  </span>
                </h4>
                <h4 className="m-0 text-white fw-bold">
                  {t("promotionBonus_pop.please_enter_code")}
                </h4>
              </div>
              <div className="py-2">
                <input
                  ref={inputRef}
                  type="text"
                  value={inputValue}
                  className="form-control text-white text-center font-bold"
                  style={{
                    background: "#1B1B26",
                    border: "#1B1B26",
                    caretColor: "white",
                    position: "relative",
                    zIndex: 1,
                  }}
                  placeholder={t("promotionBonus_pop.enter_code")}
                  onChange={handleCodeChange}
                  onFocus={handleFocus}
                  onBlur={handleBlur}
                  onKeyDown={handleKeyDown}
                  autoComplete="off"
                  onSelect={(e) => {
                    if (isIOS) {
                      // Force selection to end of input
                      const target = e.target;
                      setTimeout(() => {
                        target.setSelectionRange(
                          target.value.length,
                          target.value.length
                        );
                      }, 0);
                    }
                  }}
                />
              </div>
            </div>
            <div className=" text-center py-2">
              <Button
                onClick={() => {
                  if (inputValue && inputValue?.trim() !== "") handlePopUp();
                }}
                style={{
                  background: " #242AFC",
                  pointerEvents: isIOS && isInputFocused ? "none" : "auto",
                  opacity: isIOS && isInputFocused ? 0.7 : 1,
                }}
                className="d-flex w-100 text-uppercase align-items-center justify-content-center fw-bold commonBtn border-0"
              >
                {promotionBonusLoading ? (
                  <img
                    src={loader}
                    alt=""
                    className="img-fluid object-fit-contain"
                    style={{ height: 20 }}
                  />
                ) : (
                  t("promotionBonus_pop.next")
                )}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default PromotionBonusPop;
